(() => {
  const root = document.querySelector('[data-premium-product]');
  const gallery = root?.querySelector('[data-product-gallery]');
  const main = gallery?.querySelector('.ew-pdp-gallery__main');
  const thumbs = Array.from(gallery?.querySelectorAll('[data-media-target]') || []);
  const media = Array.from(gallery?.querySelectorAll('[data-media-id]') || []);
  const desktopMq = window.matchMedia('(min-width: 990px)');

  if (!root || !gallery || !main || media.length < 2) return;

  const makeButton = (direction, label, symbol) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `ew-pdp-desktop-nav ew-pdp-desktop-nav--${direction}`;
    button.setAttribute('aria-label', label);
    button.innerHTML = `<span aria-hidden="true">${symbol}</span>`;
    return button;
  };

  const prev = makeButton('prev', 'Previous product image', '‹');
  const next = makeButton('next', 'Next product image', '›');
  main.append(prev, next);

  const activeIndex = () => {
    const thumbIndex = thumbs.findIndex((thumb) => thumb.classList.contains('is-active'));
    if (thumbIndex >= 0) return thumbIndex;
    const mediaIndex = media.findIndex((item) => !item.hidden || item.classList.contains('is-active'));
    return mediaIndex >= 0 ? mediaIndex : 0;
  };

  const goTo = (index) => {
    if (!desktopMq.matches || !thumbs.length) return;
    const normalized = (index + thumbs.length) % thumbs.length;
    const target = thumbs[normalized];
    target?.click();
    requestAnimationFrame(() => {
      target?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    });
  };

  prev.addEventListener('click', () => goTo(activeIndex() - 1));
  next.addEventListener('click', () => goTo(activeIndex() + 1));

  main.tabIndex = 0;
  main.addEventListener('keydown', (event) => {
    if (!desktopMq.matches) return;
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      goTo(activeIndex() - 1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      goTo(activeIndex() + 1);
    }
  });
})();
